export const COUNTDOWN_TIMER_SEC = 30;
export const COUNTDOWN_TIMER_INTERVAL_MS = 1000;
export const COUNTDOWN_TIMER_INTERVAL_SEC = 1;
